<template>
  <div>
    <el-header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">{{ $t('shu-ju-zhong-xin') }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('bao-biao-guan-li') }}</el-breadcrumb-item>
      </el-breadcrumb>
    </el-header>
    <el-tabs  type="border-card" v-model="tabModel" @tab-click="reportTab">
      <el-tab-pane label="$t('ding-dan-liu-shui')" name="orderFlow">
        <el-form :inline="true" :model="orderSearchForm" class="user-search" size="mini" a>
          <el-form-item label="">
            <el-select v-model="selectedOperator" :placeholder="$t('xuan-ze-yun-ying-shang')" @change="selectOperator">
              <el-option
                v-for="item in operators"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="selectedStation" :placeholder="$t('xuan-ze-chang-zhan')">
              <el-option
                v-for="item in stations"
                :key="item.id"
                :label="item.stationName"
                :value="item.stationCode">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="custType" :placeholder="$t('ke-hu-lei-xing')" @change="selectCustType">
              <el-option
                v-for="item in custTypes"
                :key="item.id"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="orderSearchForm.phone" :placeholder="$t('shou-ji-hao-0')"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker v-model="orderSearchForm.beginTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('kai-shi-shi-jian')"></el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker v-model="orderSearchForm.endTime" type="datetime"  value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('deviceControl.EndTime')"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="searchOrderReport">{{ $t('deviceControl.search') }}</el-button>
            <el-button type="primary" icon="el-icon-download" @click="exportData">{{ $t('excel-dao-chu') }}</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="orderData" highlight-current-row border style="width: 100%;">
          <af-table-column prop="operatorId" :label="$t('deviceControl.operatorId')">
          </af-table-column>
          <af-table-column prop="stationCode" :label="$t('deviceControl.stationId')">
          </af-table-column>
          <af-table-column prop="pileCode" :label="$t('chargingMonitor.PileNumber')">
          </af-table-column>
          <af-table-column prop="gunCode" :label="$t('chargingMonitor.GunNumber')">
          </af-table-column>
          <af-table-column prop="dataFrom" :label="$t('ding-dan-lai-yuan')">
          </af-table-column>
          <af-table-column prop="phone" :label="$t('shou-ji-hao-0')">
          </af-table-column>
          <af-table-column prop="chargeTotalElectricity" :label="$t('siteMonitor.ChargingCapacity')">
          </af-table-column>
          <af-table-column prop="fee" :label="$t('fei-yong-yuan')">
          </af-table-column>
          <af-table-column prop="electricityFee" :label="$t('siteMonitor.totalElectricFee')">
          </af-table-column>
          <af-table-column prop="serviceFee" :label="$t('siteMonitor.serviceCharge')">
          </af-table-column>
          <af-table-column prop="chargeBegTime" :label="$t('chong-dian-kai-shi-shi-jian')">
          </af-table-column>
          <af-table-column prop="chargeEndTime" :label="$t('chong-dian-jie-shu-shi-jian')">
          </af-table-column>
          <af-table-column prop="chargeType" :label="$t('chong-dian-fang-shi')">
          </af-table-column>
          <af-table-column prop="payType" :label="$t('zhi-fu-fang-shi')">
          </af-table-column>
        </el-table>
        <Pagination v-bind:child-msg="pageparam" @callFather="getOrderReport"></Pagination>
      </el-tab-pane>
      <el-tab-pane :label="$t('jie-suan-dan')" name="settlementOrder">
        <el-form :inline="true" :model="settlementSearchForm" class="user-search" size="mini">
          <el-form-item label="">
            <el-select v-model="selectedOperator" :placeholder="$t('xuan-ze-yun-ying-shang')" @change="selectOperator">
              <el-option
                v-for="item in operators"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="settlementSearchForm.phone" :placeholder="$t('shou-ji-hao-0')"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="settlementSearchForm.orderNo" :placeholder="$t('ding-dan-hao')"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="settlementSearchForm.settlementNo" :placeholder="$t('jie-suan-dan-hao')"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker v-model="settlementSearchForm.beginTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            :placeholder="$t('kai-shi-shi-jian')">
            </el-date-picker>
            <el-date-picker v-model="settlementSearchForm.endTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            :placeholder="$t('deviceControl.EndTime')">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="searchSettlementReport">{{ $t('deviceControl.search') }}</el-button>
            <el-button type="primary" icon="el-icon-download" @click="exportData">{{ $t('excel-dao-chu') }}</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="settlementData" highlight-current-row border style="width: 100%;">
          <af-table-column prop="settlementNo" :label="$t('jie-suan-dan-hao-0')">
          </af-table-column>
          <af-table-column prop="operatorId" :label="$t('deviceControl.operatorId')" width="200">
          </af-table-column>
          <af-table-column prop="orderNo" :label="$t('ding-dan-hao-0')">
          </af-table-column>
          <af-table-column prop="phone" :label="$t('shou-ji-hao-0')">
          </af-table-column>
          <af-table-column prop="receAmt" :label="$t('ying-shou-jine-yuan')">
          </af-table-column>
          <af-table-column prop="actualAmt" :label="$t('shi-shou-jine-yuan')">
          </af-table-column>
          <af-table-column prop="noSettleAmt" :label="$t('wei-jie-qing-jine-yuan')">
          </af-table-column>
          <af-table-column prop="settType" :label="$t('jie-suan-lei-xing')">
          </af-table-column>
          <af-table-column prop="state" :label="$t('shi-fou-que-ren')">
          </af-table-column>
          <af-table-column prop="createTime" :label="$t('chuang-jian-shi-jian')">
          </af-table-column>
        </el-table>
        <Pagination v-bind:child-msg="pageparam" @callFather="getSettlementReport"></Pagination>
      </el-tab-pane>
      <el-tab-pane :label="$t('chang-zhan-bao-biao')" name="stationOrder">
        <el-form :inline="true" :model="stationSearchForm" class="user-search" size="mini">
          <el-select v-model="value" size="mini" :placeholder="$t('operatingViewOperator.selectPlaceholder')" @change="selectLevel">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-form-item label="">
            <el-select v-model="selectedOperator" :placeholder="$t('xuan-ze-yun-ying-shang')" @change="selectOperator">
              <el-option
                v-for="item in operators"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="selectedStation" :placeholder="$t('xuan-ze-chang-zhan-0')">
              <el-option
                v-for="item in stations"
                :key="item.id"
                :label="item.stationName"
                :value="item.stationCode">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker v-model="stationSearchForm.beginTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            :placeholder="$t('kai-shi-shi-jian')"
                            v-if="showDay">
            </el-date-picker>
            <el-date-picker v-model="stationSearchForm.endTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            :placeholder="$t('deviceControl.EndTime')"
                            v-if="showDay">
            </el-date-picker>
            <el-date-picker v-model="stationSearchForm.beginTime"
                            type="month"
                            value-format="yyyy-MM"
                            :placeholder="$t('kai-shi-shi-jian')"
                            v-if="showMonth">
            </el-date-picker>
            <el-date-picker v-model="stationSearchForm.endTime"
                            type="month"
                            value-format="yyyy-MM"
                            :placeholder="$t('deviceControl.EndTime')"
                            v-if="showMonth">
            </el-date-picker>
            <el-date-picker v-model="stationSearchForm.beginTime"
                            type="year"
                            value-format="yyyy"
                            :placeholder="$t('kai-shi-shi-jian')"
                            v-if="showYear">
            </el-date-picker>
            <el-date-picker v-model="stationSearchForm.endTime"
                            type="year"
                            value-format="yyyy"
                            :placeholder="$t('deviceControl.EndTime')"
                            v-if="showYear">
            </el-date-picker></el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="searchStationReport">{{ $t('deviceControl.search') }}</el-button>
            <el-button type="primary" icon="el-icon-download" @click="exportData">{{ $t('excel-dao-chu') }}</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="stationOrder" highlight-current-row border style="width: 100%;">
          <af-table-column prop="operatorId" :label="$t('deviceControl.operatorId')">
          </af-table-column>
          <af-table-column prop="stationId" :label="$t('deviceControl.stationId')">
          </af-table-column>
          <af-table-column prop="day" :label="$t('ri-qi')" v-if="showDay">
          </af-table-column>
          <af-table-column prop="month" :label="$t('yue-fen')" v-if="showMonth">
          </af-table-column>
          <af-table-column prop="year" :label="$t('nian-fen')" v-if="showYear">
          </af-table-column>
          <af-table-column prop="totalElectricity" :label="$t('siteMonitor.ChargingCapacity')">
          </af-table-column>
          <af-table-column prop="totalFee" :label="$t('siteMonitor.ChargingIncome')">
          </af-table-column>
          <af-table-column prop="totalElectricityFee" :label="$t('siteMonitor.totalElectricFee')">
          </af-table-column>
          <af-table-column prop="serviceFee" :label="$t('siteMonitor.serviceCharge')">
          </af-table-column>
          <af-table-column prop="orderNum" :label="$t('fu-wu-ci-shu-ci')">
          </af-table-column>
        </el-table>
        <Pagination v-bind:child-msg="pageparam" @callFather="getStationReport"></Pagination>
      </el-tab-pane>
      <el-tab-pane :label="$t('yun-ying-shang-bao-biao')" name="operatorOrder">
        <el-form :inline="true" :model="operatorSearchForm" class="user-search" size="mini">
          <el-select v-model="value" size="mini" :placeholder="$t('qing-xuan-ze-wei-du')" @change="selectLevel">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-form-item label="">
            <el-select v-model="selectedOperator" :placeholder="$t('xuan-ze-yun-ying-shang')" @change="selectOperator">
              <el-option
                v-for="item in operators"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker v-model="operatorSearchForm.beginTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            :placeholder="$t('kai-shi-shi-jian')"
                            v-if="showDay">
            </el-date-picker>
            <el-date-picker v-model="operatorSearchForm.endTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            :placeholder="$t('deviceControl.EndTime')"
                            v-if="showDay">
            </el-date-picker>
            <el-date-picker v-model="operatorSearchForm.beginTime"
                            type="month"
                            value-format="yyyy-MM"
                            :placeholder="$t('kai-shi-shi-jian')"
                            v-if="showMonth">
            </el-date-picker>
            <el-date-picker v-model="operatorSearchForm.endTime"
                            type="month"
                            value-format="yyyy-MM"
                            :placeholder="$t('deviceControl.EndTime')"
                            v-if="showMonth">
            </el-date-picker>
            <el-date-picker v-model="operatorSearchForm.beginTime"
                            type="year"
                            value-format="yyyy"
                            :placeholder="$t('kai-shi-shi-jian')"
                            v-if="showYear">
            </el-date-picker>
            <el-date-picker v-model="operatorSearchForm.endTime"
                            type="year"
                            value-format="yyyy"
                            :placeholder="$t('deviceControl.EndTime')"
                            v-if="showYear">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="searchOperatorReport">{{ $t('deviceControl.search') }}</el-button>
            <el-button type="primary" icon="el-icon-download" @click="exportData">{{ $t('excel-dao-chu') }}</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="operatorOrder" highlight-current-row border style="width: 100%;">
          <af-table-column prop="operatorId" :label="$t('deviceControl.operatorId')">
          </af-table-column>
          <af-table-column prop="day" :label="$t('ri-qi')" v-if="showDay">
          </af-table-column>
          <af-table-column prop="month" :label="$t('yue-fen')" v-if="showMonth">
          </af-table-column>
          <af-table-column prop="year" :label="$t('nian-fen')" v-if="showYear">
          </af-table-column>
          <af-table-column prop="totalElectricity" :label="$t('siteMonitor.ChargingCapacity')">
          </af-table-column>
          <af-table-column prop="totalFee" :label="$t('siteMonitor.ChargingIncome')">
          </af-table-column>
          <af-table-column prop="totalElectricityFee" :label="$t('siteMonitor.totalElectricFee')">
          </af-table-column>
          <af-table-column prop="serviceFee" :label="$t('siteMonitor.serviceCharge')">
          </af-table-column>
          <af-table-column prop="orderNum" :label="$t('fu-wu-ci-shu-ci')">
          </af-table-column>
        </el-table>
        <Pagination v-bind:child-msg="pageparam" @callFather="getOperatorReport"></Pagination>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import Pagination from '../../../components/Pagination'
  import api from '@/module/dataCenter/api/report.js'
  export default {
    components: {Pagination},
    name: 'reportManage',
    data() {
      return {
        tabModel:"orderFlow",
        operatorOrder:[],
        stationOrder:[],
        orderData: [],
        settlementData: [],
        // searchForm:{},
        orderSearchForm:{},
        settlementSearchForm:{},
        stationSearchForm:{},
        operatorSearchForm:{},
        options: [{
          value: '1',
          label: this.$t('mei-tian-ding-dan')
        }, {
          value: '2',
          label: this.$t('mei-yue-ding-dan')
        }, {
          value: '3',
          label: this.$t('mei-nian-ding-dan')
        }],
        custTypes: [{
          value: '1',
          label: this.$t('ge-ren')
        }, {
          value: '2',
          label: this.$t('ji-tuan')
        }],
        value: '1',//下拉选择框选中值
        pageparam: {
          t: {},
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
        showDay: true,
        showMonth: false,
        showYear: false,
        tabPosition: 'order',//tab标签位置，流水（order）,站报表（stationOrder）,运营商报表(operatorOrder),
        operators: '',
        selectedOperator:'',
        stations: '',
        selectedStation: '',
        selectedCustType:'',
        payType : '',
        custType: ''
      }
    },
    methods: {
      //加载运营商列表
      loadOperators() {
        api.operatorList().then((res) => {
          this.operators = res.data
        })
      },
      selectOperator() {
        api.stationList([this.selectedOperator]).then((res)=>{
          this.stations = res.data
        })
      },
      selectCustType(val){
        switch(val){
          case '2' :{
            this.payType = 'credit'
            break;
          }
          case '1':{
            this.payType = 'other'
            break;
          }
        }
      },
      searchOrderReport(){
        this.getOrderReport()
      },
      searchOperatorReport(){
        this.getOperatorReport()
      },
      searchStationReport(){
        this.getStationReport()
      },
      searchSettlementReport(){
        this.getSettlementReport()
      },
      operatorDailyOrder(param){
        api.getOperatorDailyReport(param).then((res)=>{
          if (res.code === 0) {
            this.pageparam.total = res.data.total
            this.operatorOrder = res.data.list
          } else {
            this.$message.error(res.message);
          }
        })
      },
      operatorMonthlyOrder(param){
        api.getOperatorMonthlyReport(param).then((res)=>{
          if (res.code === 0) {
            this.pageparam.total = res.data.total
            this.operatorOrder = res.data.list
          } else {
            this.$message.error(res.message);
          }
        })
      },
      operatorYearlyOrder(param){
        api.getOperatorYearlyReport(param).then((res)=>{
          if (res.code === 0) {
            this.pageparam.total = res.data.total
            this.operatorOrder = res.data.list
          } else {
            this.$message.error(res.message);
          }
        })
      },
      stationDailyOrder(param){
        api.getStationDailyReport(param).then((res)=>{
          if (res.code === 0) {
            this.pageparam.total = res.data.total
            this.stationOrder = res.data.list
          } else {
            this.$message.error(res.message);
          }
        })
      },
      stationMonthlyOrder(param){
        api.getStationMonthlyReport(param).then((res)=>{
          if (res.code === 0) {
            this.pageparam.total = res.data.total
            this.stationOrder = res.data.list
          } else {
            this.$message.error(res.message);
          }
        })
      },
      stationYearlyOrder(param){
        api.getStationYearlyReport(param).then((res)=>{
          if (res.code === 0) {
            this.pageparam.total = res.data.total
            this.stationOrder = res.data.list
          } else {
            this.$message.error(res.message);
          }
        })
      },
      async exportData(){
        //运营商报表导出
        if (this.tabPosition === 'operatorOrder') {
          switch(this.value) {
            case '1' : {
              api.downloadOperator(this.selectedOperator).then((res)=>{
                if (res){
                  this.downloadExcel(res,this.$t('yun-ying-shang-mei-tian-ding-dan-hui-zong'))
                }
              })
              break;
            }
            case '2' : {
              api.downloadOperator2(this.selectedOperator).then((res)=>{
                if (res){
                  this.downloadExcel(res,this.$t('yun-ying-shang-mei-yue-ding-dan-hui-zong'))
                }
              })
              break;
            }
            case '3' : {
              api.downloadOperator3(this.selectedOperator).then((res)=>{
                if (res){
                  this.downloadExcel(res,this.$t('yun-ying-shang-mei-nian-ding-dan-hui-zong'))
                }
              })
              break;
            }
          }
        }
        //场站报表导出
        if (this.tabPosition === 'stationOrder') {
          switch(this.value) {
            case '1' : {
              api.downloadStation().then((res)=>{
                if (res){
                  this.downloadExcel(res,this.$t('chang-zhan-mei-tian-ding-dan-hui-zong'))
                }
              })
              break;
            }
            case '2' : {
              api.downloadStation2().then((res)=>{
                if (res){
                  this.downloadExcel(res,this.$t('chang-zhan-mei-yue-ding-dan-hui-zong'))
                }
              })
              break;
            }
            case '3' : {
              api.downloadStation3().then((res)=>{
                if (res){
                  this.downloadExcel(res,this.$t('chang-zhan-mei-nian-ding-dan-hui-zong'))
                }
              })
              break;
            }
          }
        }
        //订单报表
        if (this.tabPosition === 'order') {
          let param = {
            operatorId :this.selectedOperator,
            stationCode:this.selectedStation,
            payType: this.payType,
            chargeBegTime : this.orderSearchForm.beginTime===undefined?'':this.orderSearchForm.beginTime,
            chargeEndTime : this.orderSearchForm.endTime===undefined?'':this.orderSearchForm.beginTime
          }
          api.downloadOrder(param).then((res)=>{
            if (res){
              this.downloadExcel(res,this.$t('ding-dan-liu-shui'))
            }
          })
        }
        //结算单
        if (this.tabPosition === 'settlement') {
          let param = {
            operatorId :this.selectedOperator,
            beginTime : this.settlementSearchForm.beginTime===undefined?'':this.settlementSearchForm.beginTime,
            endTime : this.settlementSearchForm.endTime===undefined?'':this.settlementSearchForm.endTime,
            settlementNo : this.settlementSearchForm.settlementNo===undefined?'':this.settlementSearchForm.settlementNo,
            orderNo : this.settlementSearchForm.orderNo===undefined?'':this.settlementSearchForm.orderNo
          }
          api.downSettlement(param).then((res)=>{
            if (res){
              this.downloadExcel(res,this.$t('jie-suan-dan-0'))
            }
          })
        }
      },
      reportTab(tab,event) {
        if (tab.label === this.$t('ding-dan-liu-shui')) {
          this.selectedOperator = ''
          this.selectedStation = ''
          this.tabPosition = 'order'
          this.getOrderReport()
        }
        if (tab.label === this.$t('jie-suan-dan-1')) {
          this.selectedOperator = ''
          this.selectedStation = ''
          this.tabPosition = 'settlement'
          this.getSettlementReport()
        }
        if (tab.label === this.$t('chang-zhan-bao-biao-0')) {
          this.selectedOperator = ''
          this.selectedStation = ''
          this.value = '1'
          this.tabPosition = 'stationOrder'
          this.getStationReport()
        }
        if (tab.label === this.$t('yun-ying-shang-bao-biao-0')) {
          this.selectedOperator = ''
          this.selectedStation = ''
          this.value = '1'
          this.tabPosition = 'operatorOrder'
          this.getOperatorReport()
        }
      },
      //依据选择的维度（日/月/年）获取表格数据
      selectLevel(){
        //位于运营商报表tab页
        if (this.tabPosition === 'operatorOrder') {
          this.operatorSearchForm.beginTime = ''
          this.operatorSearchForm.endTime = ''
          switch(this.value){
            case '1':{
              this.showDay = true
              this.showMonth = false
              this.showYear = false
              this.operatorDailyOrder()
              break;
            }
            case '2':{
              this.showDay = false
              this.showMonth = true
              this.showYear = false
              this.operatorMonthlyOrder()
              break;
            }
            case '3':{
              this.showDay = false
              this.showMonth = false
              this.showYear = true
              this.operatorYearlyOrder()
              break;
            }
          }
        }
        //位于站报表tab页
        if (this.tabPosition === 'stationOrder') {
          this.stationSearchForm.beginTime = ''
          this.stationSearchForm.endTime = ''
          switch(this.value){
            case '1':{
              this.showDay = true
              this.showMonth = false
              this.showYear = false
              this.stationDailyOrder()
              break;
            }
            case '2':{
              this.showDay = false
              this.showMonth = true
              this.showYear = false
              this.stationMonthlyOrder()
              break;
            }
            case '3':{
              this.showDay = false
              this.showMonth = false
              this.showYear = true
              this.stationYearlyOrder()
              break;
            }
          }
        }
      },
      getOperatorReport(){
        this.pageparam.t = {
          operatorId: this.selectedOperator,
          beginTime: this.operatorSearchForm.beginTime===undefined?'':this.operatorSearchForm.beginTime,
          endTime: this.operatorSearchForm.endTime===undefined?'':this.operatorSearchForm.endTime
        }
        let param = Object.assign({}, this.pageparam)
        switch(this.value){
          case '1':{
            this.operatorDailyOrder(param)
            break;
          }
          case '2':{
            this.operatorMonthlyOrder(param)
            break;
          }
          case '3':{
            this.operatorYearlyOrder(param)
            break;
          }
        }
      },
      getStationReport(){
        this.pageparam.t = {
          operatorId: this.selectedOperator,
          stationCode: this.selectedStation,
          beginTime: this.stationSearchForm.beginTime===undefined?'':this.stationSearchForm.beginTime,
          endTime: this.stationSearchForm.endTime===undefined?'':this.stationSearchForm.endTime
        }
        let param = Object.assign({}, this.pageparam)
        switch(this.value){
          case '1':{
            this.stationDailyOrder(param)
            break;
          }
          case '2':{
            this.stationMonthlyOrder(param)
            break;
          }
          case '3':{
            this.stationYearlyOrder(param)
            break;
          }
        }
      },
      orderReport(param){
        api.getOrderReport(param).then((res)=>{
          if (res.code === 0) {
            this.pageparam.total = res.data.total
            this.orderData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        })
      },
      getOrderReport(){
        this.pageparam.t = {
          operatorId: this.selectedOperator,
          stationCode: this.selectedStation,
          payType:this.payType,
          beginTime: this.orderSearchForm.beginTime===undefined?'':this.orderSearchForm.beginTime,
          endTime: this.orderSearchForm.endTime===undefined?'':this.orderSearchForm.endTime
        }
        let param = Object.assign({}, this.pageparam)
        this.orderReport(param)
      },
      settlementReport(param){
        api.getSettlementReport(param).then((res)=>{
          if (res.code === 0) {
            this.pageparam.total = res.data.total
            this.settlementData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        })
      },
      getSettlementReport(){
        this.pageparam.t = {
          operatorId :this.selectedOperator,
          phone : this.settlementSearchForm.phone===undefined?'':this.settlementSearchForm.phone,
          beginTime : this.settlementSearchForm.beginTime===undefined?'':this.settlementSearchForm.beginTime,
          endTime : this.settlementSearchForm.endTime===undefined?'':this.settlementSearchForm.endTime,
          settlementNo : this.settlementSearchForm.settlementNo===undefined?'':this.settlementSearchForm.settlementNo,
          orderNo : this.settlementSearchForm.orderNo===undefined?'':this.settlementSearchForm.orderNo
        }

        let param = Object.assign({}, this.pageparam)
        this.settlementReport(param)
      },
      //下载excel,res为要导出的内容，name为文件名
      downloadExcel(res,name) {
        const blob = new Blob([res],{
          type: 'application/vnd.ms-excel;charset=utf-8'
        })
        const downloadElement = document.createElement('a')
        const href = window.URL.createObjectURL(blob)
        downloadElement.href = href
        downloadElement.download = name+'.xlsx'
        document.body.appendChild(downloadElement)
        downloadElement.click()
        document.body.removeChild(downloadElement) // 下载完成移除元素
        window.URL.revokeObjectURL(href) // 释放掉blob对象
      }
    },
    mounted(){
      this.loadOperators()
      this.getOrderReport()
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/dataCenter/page/reportManage.vue